import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { mapCustomerOrderMeta } from '#/modules/crmMgmt/customerOrder/helper/mapCustomerOrderMeta';

function AmountCell({ label, value }) {
  return (
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">{value}</p>
    </div>
  );
}

AmountCell.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

const CustomerOrderAmountSection = ({ detail }) => {
  const meta = mapCustomerOrderMeta(detail);

  if (!meta.hasAmount) {
    return null;
  }

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <h2 className="text-base font-semibold text-gray-900">金額</h2>
        <div
          className={cn(
            'mt-4 grid grid-cols-1 gap-x-4 gap-y-3',
            'sm:grid-cols-2 md:grid-cols-3',
          )}
        >
          <AmountCell label="小計" value={meta.subtotalAmount} />
          <AmountCell label="稅額" value={meta.taxAmount} />
          <AmountCell label="折扣" value={meta.discountAmount} />
          <AmountCell label="尾差調整" value={meta.roundingAdjustment} />
          <AmountCell label="淨額" value={meta.netAmount} />
          <AmountCell label="合計" value={meta.totalAmount} />
        </div>
      </div>
    </div>
  );
};

CustomerOrderAmountSection.propTypes = {
  detail: PropTypes.object.isRequired,
};

export default CustomerOrderAmountSection;
